import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { axios } from "@via/api/axios.tsx";
import {
  type KnowledgeBuilderAssistantListItem,
  type ListKnowledgeBuilderAssistantsResponse,
} from "common";

type KnowledgeBuilderAssistantForDrawer = Pick<
  KnowledgeBuilderAssistantListItem,
  "id" | "name" | "model" | "ingestStatus"
>;

async function fetchKnowledgeBuilderAssistants(): Promise<
  KnowledgeBuilderAssistantForDrawer[]
> {
  try {
    const res = await axios.get<ListKnowledgeBuilderAssistantsResponse>(
      "/api/v1/cortex/knowledge-builder/assistants",
      { params: { take: 10, skip: 0 } }
    );
    const assistants = (res.data?.data ??
      []) as KnowledgeBuilderAssistantForDrawer[];
    // Only show assistants that are ready to answer questions.
    return assistants.filter(a => (a.ingestStatus ?? "ready") === "ready");
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export function useKnowledgeBuilderAssistantsForDrawer(
  enabled: boolean = true
): UseQueryResult<KnowledgeBuilderAssistantForDrawer[], Error> {
  return useQuery({
    queryKey: ["/api/v1/cortex/knowledge-builder/assistants", "drawer"],
    queryFn: fetchKnowledgeBuilderAssistants,
    enabled,
  });
}
